if (document.querySelector(".backinstock_feature_enable")) {

  // back in stock feature for product page
  if (document.querySelector(".t4s-section-main-product")) {

    function validatePhoneNumber() {
      const phoneNumber = document.getElementById('stock-phone').value.trim();

      const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

      return pattern.test(phoneNumber);
    }

    document.getElementById('stock-phone').addEventListener("keyup", (e) => {
      let phone_value = e.target.value;
      if (phone_value != "") {
        validatePhoneNumber();
      } else {
        document.getElementById('phoneValidationMsg').textContent = "";
        document.getElementById('phoneValidationMsg').style.color = "";
      }
    });

    document.querySelector(".matat-stock-notify-submit").addEventListener("click", () => {
      document.getElementById('phoneValidationMsg').textContent = '';
      let check_phone = validatePhoneNumber();

      if (check_phone) {

        const button = document.querySelector(".matat-stock-notify-submit");
        const data = {
          phone: document.getElementById("stock-phone").value,
          dialCode: "972",
          id: button.getAttribute("data-id"),
          product_id: button.getAttribute("data-product_id"),
          action: button.getAttribute("data-action"),
          title: button.getAttribute("data-title"),
          price_varies: JSON.parse(button.getAttribute("data-price_varies")),
          price: button.getAttribute("data-price"),
          price_max: button.getAttribute("data-price_max"),
          price_min: button.getAttribute("data-price_min"),
          has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
          src: button.getAttribute("data-src"),
          url: button.getAttribute("data-url"),
          user_id: button.getAttribute("data-user_id"),
          email: button.getAttribute("data-email"),
          full_name: button.getAttribute("data-full_name"),
          variant_id: button.getAttribute("data-variant-id"),
          variant_title: button.getAttribute("data-variant-title")
        };

        fetch(`https://datiya.co.il/apps/text-me/restock-notifications`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "x-shopify-shop-domain": Shopify.shop
          },
          body: JSON.stringify(data)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
          })
          .then(() => {
            document.getElementById('phoneValidationMsg').style.color = "green";
            document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
          })
          .catch(error => {
            console.error('Error:', error);
          });

      } else {
        document.getElementById('phoneValidationMsg').textContent = "מספר טלפון לא תקין.";
      }
    });

    document.querySelector('[name="id"]').addEventListener("change", (e) => {
      let variant_change_val = e.target.value;
      document.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id", variant_change_val);
      document.querySelector(".matat-stock-notify-submit").setAttribute("data-id", variant_change_val);
    });

  } // END product page check

  class BackinStockmatat extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", () => {
        document.querySelector(".matat-product-card-stock").classList.toggle("active");
        document.body.classList.toggle("overflow-hidden");
        let $AllAttributes = this.attributes;
        this.copyAttributes($AllAttributes);
      });
    }
  }

  customElements.define('matat-stock', BackinStockmatat);

} // END backinstock_feature_enable
